(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const containers = document.querySelectorAll('[data-nr-card-gallery]');
  if (!containers.length) return;

  const INTERVAL_MS = 700;
  const MAX_SHOWN = 10;
  const SHOW_VIEW_ALL_CLASS = 'blog-post-card__image-container--show-view-all';

  containers.forEach(function (container) {
    const img = container.querySelector('img');
    if (!img) return;

    const urls = container
      .getAttribute('data-nr-card-gallery')
      .split('|')
      .filter(Boolean);

    if (urls.length < 2) return;

    let index = 0;
    let shownCount = 0;
    let timer = null;
    const originalSrc = img.currentSrc || img.src;
    const originalSrcset = img.getAttribute('srcset');
    const originalWidth = img.getAttribute('width');
    const originalHeight = img.getAttribute('height');

    function show(nextIndex) {
      index = ((nextIndex % urls.length) + urls.length) % urls.length;
      img.src = urls[index];
      img.removeAttribute('srcset');
      img.removeAttribute('width');
      img.removeAttribute('height');
    }

    function revealViewAll() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }

      container.classList.add(SHOW_VIEW_ALL_CLASS);
    }

    function start() {
      shownCount = 1;
      container.classList.remove(SHOW_VIEW_ALL_CLASS);
      show(0);

      timer = window.setInterval(function () {
        if (shownCount >= MAX_SHOWN) {
          revealViewAll();
          return;
        }

        show(index + 1);
        shownCount += 1;

        if (shownCount >= MAX_SHOWN) {
          revealViewAll();
        }
      }, INTERVAL_MS);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }

      container.classList.remove(SHOW_VIEW_ALL_CLASS);
      shownCount = 0;
      img.src = originalSrc;

      if (originalSrcset) {
        img.setAttribute('srcset', originalSrcset);
      } else {
        img.removeAttribute('srcset');
      }

      if (originalWidth) {
        img.setAttribute('width', originalWidth);
      }

      if (originalHeight) {
        img.setAttribute('height', originalHeight);
      }
    }

    container.addEventListener('mouseenter', start);
    container.addEventListener('mouseleave', stop);
  });
})();
